import { Component, inject } from '@angular/core';
import { MetaDataService } from '../metadata.service';
import { AsyncPipe } from '@angular/common';
import { ImageModifierPipe } from '../image-modifer.pipe';

@Component({
    selector: 'tea-shop-fe-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.css'],
    imports: [AsyncPipe, ImageModifierPipe]
})
export class AboutComponent {
  private metaDataService = inject(MetaDataService);

  constructor() {
    this.metaDataService.updateMetadata({
      title: 'About - Sencha Tea',
      image: '/assets/tea-type-lady/green-tea-lady.png',
    });
  }
}
